export { default as DarkFooter } from "./dark";
